import { resolveBrandAssetSrc } from '@/features/shared/brand/branding-core'
import { useBranding } from '@/features/shared/brand/branding-hooks'

export function AuthBrandHeader({ title }: { title?: string }) {
  const {
    settings: { hasCustomTitle, logo, title: brandTitle },
  } = useBranding()
  const displayedTitle = hasCustomTitle ? brandTitle : (title ?? brandTitle)

  return (
    <header className="flex flex-col items-center">
      <div className="flex size-[42px] items-center justify-center">
        <img alt="" className="size-[42px]" src={resolveBrandAssetSrc(logo)} />
      </div>
      <h1 className="mt-5 text-center text-xl font-semibold leading-none text-[var(--color-text)]">
        {displayedTitle}
      </h1>
    </header>
  )
}
